const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class Phalanx extends Tactic {
    constructor() {
        super(
            Age.Age1,
            TacticNames.Phalanx,
            [2, 1, 0],
            "3",
            {}
        )
    }
}

module.exports = Phalanx;